
import "../css/AppPage.css";
import { Menu } from "./Menu";
import { LoadingPageData } from '../classes/LoadingPageData';

import { useState, useEffect } from 'react';

// Components

import Header from './Components-AppPage/Header';

// -- Redux ----------------------------------------------

import { useDispatch, useSelector } from 'react-redux';

// Dispatchers

import { 
	setAppPage
} from '../store/appStateReducers';

// Selectors
import {
	getDataById
} from '../store/dataStateReducers';

export const AppPage = (props) => {

	const dispatch = useDispatch();

	const app_data = useSelector( (state) => getDataById(state, "app_data") );
	const uid_data = useSelector( (state) => getDataById(state, "uid_data") );

	const period_apps_parameters_js = app_data.data_js.period_apps_parameters_js;
	
	const app_data_errors_js = app_data.errors_js;
	
	var jsx;

	if ( Object.keys(app_data_errors_js).includes('app') ) {
		
		jsx = <div>There are no scheduled activities!</div>;

	} else {
	
		
		const app_data_js_a = app_data.data_js.app_data_js_a;		
		const uid_data_js = uid_data.data_js.uid_data_js;
	
		let js_a = app_data_js_a.map( (elem) => { 
	
			let row_js = Object.assign({},elem);
	
			// Note:
			if ( period_apps_parameters_js[elem.uniq] === undefined ) {
				row_js['note'] = '';
			} else{
				row_js['note'] = period_apps_parameters_js[elem.uniq]['note'];
			}
			
		
			// Student data:
			let js;
			let user_data_jsx;
			if ( uid_data_js[elem.uniq] === undefined ) {
				user_data_jsx = <></>;
			} else {
				js = uid_data_js[elem.uniq];
				var d = ( new Date(js.datetime_javascript) )
					.toLocaleString()
					.replace(/:.. (.)M$/,"$1M");
				user_data_jsx = <>{js.score} ({js.earned}/{js.possible})<br />{d}</>;
			}
			
			row_js['user_data_jsx'] = user_data_jsx;
	
			return row_js;
			
		});
	
		var activity_group_named_a = [];
		const activity_group_func = (elem) => {
			let jsx;
			if ( !activity_group_named_a.includes(elem) ) {
				activity_group_named_a.push(elem);
				jsx = <span className='activity_group_name_span'>{elem}</span>;
			} else {
				jsx = <></>;
			}
			return jsx;
		}
	
		const app_data_jsx_a = js_a.map( (elem, i) => {
			let jsx = <tr key={i+1}>
						<td className="td_activity_group">
							{activity_group_func(elem.activity_group)}
						</td>
						<td>
							<button type="button" className="btn btn-link" onClick={() => setUniqClicked(elem.uniq)}>{elem.activity}</button>
						</td>
						<td>
							{elem.note}
						</td>
						<td>
							{elem.user_data_jsx}
						</td>
					</tr>
			return jsx;
		});
	
		jsx = <table>
			<thead>
				<tr>
					<th className='activity_group_class'></th>
					<th className='activity_class'>Activity</th>
					<th className='notes_class'>Notes</th>
					<th>My progress</th>
				</tr>
			</thead>
			<tbody>
				{app_data_jsx_a}
			</tbody>
		</table>;
	}

	const [uniq_clicked, setUniqClicked] = useState('none');
	useEffect( () => {
			if ( uniq_clicked !== 'none' ) {

				const loadingPageData = new LoadingPageData("activityPage");
				loadingPageData.setDataIdPhpScriptPair(
					'activity_data',
					'php/activity_get.php',
					{uniq: uniq_clicked}
					);
				const loadingPageDataProps = loadingPageData.getData().data;

				dispatch( 
					setAppPage(
						{ 	page: "loadingPage",
							props: loadingPageDataProps
						}
					)
				);

			}
		},
	[
		uniq_clicked,
		dispatch
	]);


	return (
		<>
			<Menu items={['selectAppPage','appPage','logOut']} />
			<Header />
			<div>{jsx}</div>
		</>
	);
}